import request from '@/utils/request';

export const getTeamStatList = data => request({
  url: '/v1/topic/teamStatList',
  data:{leagueId: process.env.VUE_APP_LEAGUEID, ...data},
})



